// Based on https://github.com/zeh/prando
class DRandom {
	private static MIN:number = -2147483648; // Int32 min
	private static MAX:number = 2147483647; // Int32 max

	private _seed:number;
	private _value:number;

	constructor(seed:number|string) {
		if (typeof(seed) === "string") {
			this._seed = this.hashCode(<string>seed);
			this._value = this._seed;
		} else if (typeof(seed) === "number") {
			this._seed = <number>seed;
			this._value = this._seed;
		} else {
			throw new Error('DRandom incorrect seed');
		}
		
	}

	public next(min:number = 0, pseudoMax:number = 1):number {
		this.recalculate();
		return this.map(this._value, DRandom.MIN, DRandom.MAX, min, pseudoMax);
	}

	private recalculate():void {
		// Xorshift*32
		// Based on George Marsaglia's work: http://www.jstatsoft.org/v08/i14/paper
		this._value ^= this._value << 13;
		this._value ^= this._value >> 17;
		this._value ^= this._value << 5;
	}

	private map(val:number, minFrom:number, maxFrom:number, minTo:number, maxTo:number) {
		return ((val - minFrom) / (maxFrom - minFrom)) * (maxTo - minTo) + minTo;
	}

	private hashCode(str:string):number {
		let hash:number = 0;
		if (str) {
			let l:number = str.length;
			for (let i = 0; i < l; i++) {
				hash = ((hash << 5) - hash) + str.charCodeAt(i);
				hash |= 0;
			}
		}
		return hash;
	}
}